import React, { useContext } from 'react';
import { useNavigate } from '@reach/router';
import logo from '../images/logo/logo.png';
import '../App.css';

import { Store } from '../data/Store';
import { updateLocalView } from '../data/Actions';

import styled from 'styled-components';

const NextStyle = styled.div`
    [view="USER"] {
        .user {
            color: #1890ff!important;
        }
    }
    [view="TEMP"] {
        .temp {
            color: #1890ff!important;
        }
    }
    [view="ADMIN"] {
        .admin {
            color: #1890ff!important;
        }
    }
`;

function PedTypeSwithch(props) {
    const { state, dispatch } = useContext(Store);
    const navigate = useNavigate();

    if (!props.path.includes('/pedigree')) {
        return (
            <ul id="navbar--list" view={(props.path.includes('/admin')) ? 'ADMIN' : state.PedType}>
                <li className="nav-item"><a href="/" className="navbar--list__link">MAIN WEBSITE</a></li>
                <li className="nav-item"
                    onClick={()=>{
                                updateLocalView({PedType: 'USER'}, state, dispatch);
                                navigate(`${process.env.PUBLIC_URL}/`);
                            }}>
                        <a className="navbar--list__link user">PEDIGREE</a>
                </li>
                <li className="nav-item"
                    onClick={()=>{
                                updateLocalView({PedType: 'TEMP'}, state, dispatch);
                                navigate(`${process.env.PUBLIC_URL}/template`);
                            }}>
                        <a className="navbar--list__link temp">PRODUCT TEMPLATE</a>
                </li>
                <li className="nav-item"><a onClick={()=>navigate(`${process.env.PUBLIC_URL}/admin`)} className="navbar--list__link admin">USER</a></li>
                <li onClick={props.signout} style={{'height':'auto'}} className="nav-item epedigreebutton"><a>Sign Out</a></li>
            </ul>
        );
    } else {
        return (
            <ul id="navbar--list" view={state.PedType}>
                <li className="nav-item"><a href="/" className="navbar--list__link">MAIN WEBSITE</a></li>
                <li onClick={props.signout} style={{'height':'auto'}} className="nav-item epedigreebutton"><a>Sign Out</a></li>
            </ul>
        );
    }
}

export default function WebHeader(props) {
    const { state, dispatch } = useContext(Store);
    return (
        <div>
            <div className="nav-container"> 
                <nav className="navbar" style={{'maxWidth': 'none'}}>
                    <div className="navbar--row">
                        <div className="col-12 navbar--logo">
                            <div className="row logo center-justify">
                                <a href="/"><img src={logo} alt="PharmPak" /></a>
                            </div>
                            <div className="row tagline center-justify">
                                <span className="opensans italic logotagline">The Bottom Line is Patient Care.</span>
                            </div>
                        </div>
                        <span id="navbar--toggle">
                            <i className="fas fa-bars"></i>
                        </span>
                    </div>
                    <NextStyle>
                    {
                        (state.User === 'ADMIN') ? (
                            <PedTypeSwithch path={props.path.pathname} signout={props.signout}></PedTypeSwithch>
                        ) : (
                            <ul id="navbar--list"> 
                                <li className="nav-item"><a className="navbar--list__link activenav" href="/index.html">HOME</a></li>
                                <li className="nav-item"><a className="navbar--list__link" href="/about.html">ABOUT US</a></li>
                                <li className="nav-item"><a className="navbar--list__link" href="/products.html">PRODUCT/SERVICES</a></li>
                                <li className="nav-item"><a className="navbar--list__link" href="/contact.html">CONTACT US</a></li>
                                <li onClick={props.signout} style={{'height':'auto'}} className="nav-item epedigreebutton"><a>Sign Out</a></li> 
                            </ul>
                        )
                    }
                    </NextStyle>
                </nav> 
            </div>
        </div>
    );
}